import * as React from "react";

export function useStickyAutoHideHeader({
  hideAfter = 120,
  topOffset = 4,
} = {}) {
  const [isVisible, setIsVisible] = React.useState(true);
  const [isAtTop, setIsAtTop] = React.useState(true);

  const lastYRef = React.useRef(0);
  const tickingRef = React.useRef(false);

  React.useEffect(() => {
    lastYRef.current = window.scrollY || 0;
    setIsAtTop((window.scrollY || 0) <= topOffset);

    const update = () => {
      tickingRef.current = false;

      const y = window.scrollY || 0;
      const lastY = lastYRef.current;
      const delta = y - lastY;

      const nextAtTop = y <= topOffset;
      setIsAtTop((prev) => (prev === nextAtTop ? prev : nextAtTop));

      const minDelta = 1;
      if (Math.abs(delta) < minDelta) {
        lastYRef.current = y;
        return;
      }

      const scrollingDown = delta > 0;
      const scrollingUp = delta < 0;

      if (scrollingUp) {
        setIsVisible((prev) => (prev ? prev : true));
      }

      if (scrollingDown && y > hideAfter) {
        setIsVisible((prev) => (prev ? false : prev));
      }

      if (nextAtTop) {
        setIsVisible((prev) => (prev ? prev : true));
      }

      lastYRef.current = y;
    };

    const onScroll = () => {
      if (tickingRef.current) return;
      tickingRef.current = true;
      window.requestAnimationFrame(update);
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [hideAfter, topOffset]);

  return { isVisible, isAtTop };
}
